var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.card},[_c('div',{class:_vm.$style.logo},[_c('img',{attrs:{"src":_vm.logo,"alt":_vm.title}})]),_vm._v(" "),_c('AlButton',{attrs:{"to":_vm.link,"theme":"dark","size":"xxs"}},[_vm._v("\n    "+_vm._s(_vm.$t('header.findRegularPlan'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }